import { useSelector } from 'app-redux'
import { selectParam } from 'features/param-toggler/param-toggler-redux'

export type RecordingUserState = {
	active: boolean
}

export function useRecordingUser(): RecordingUserState {
	const recordingParam = useSelector(state => selectParam(state, 'recording'))
	const active = recordingParam === true || recordingParam === 'true'
	return { active }
}
